import axios from "axios";

import { UserCompaniesType, UserDataType } from "@winshop-crm/types";

export type GetUserDataProps = {
  userId: string;
  token: string;
  email: string;
  internal?: boolean;
};

export type GetUserDataResponse = {
  userData: UserDataType;
  userCompanies?: UserCompaniesType[];
};

const getUserData = async ({
  userId,
  token,
  email,
  internal = false,
}: GetUserDataProps): Promise<GetUserDataResponse> => {
  const apiUrl = new URL(
    `${
      internal == true ? process.env.NEXT_PUBLIC_INTERNAL_URL : process.env.NEXT_PUBLIC_URL
    }/api/user/info`
  );
  const params = [
    ["userId", userId],
    ["token", token],
    ["email", email],
  ];
  apiUrl.search = new URLSearchParams(params).toString();

  const response = await axios<GetUserDataResponse>({
    url: apiUrl.href,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};

export default getUserData;
